import React from "react";
import { FaBars, FaTimes } from "react-icons/fa";

function HamburgerMenu({ isOpen, onToggle }) {
  return (
    <button
      className="hamburger-menu d-md-none"
      onClick={onToggle}
      aria-label={isOpen ? "Close menu" : "Open menu"}
      aria-expanded={isOpen}
    >
      {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
    </button>
  );
}

export default HamburgerMenu;
